var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    zoomAndPan: "magnify",
    viewBox: "0 0 36 36.000001",
    height: 48,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "755640a5c8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.410156 5.921875 L 29.761719 5.921875 L 29.761719 29.273438 L 6.410156 29.273438 Z M 6.410156 5.921875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8aaa6929d0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.761719 17.597656 C 29.761719 18.363281 29.683594 19.125 29.535156 19.875 C 29.386719 20.628906 29.164062 21.359375 28.871094 22.066406 C 28.578125 22.773438 28.21875 23.445312 27.792969 24.085938 C 27.367188 24.722656 26.882812 25.3125 26.339844 25.855469 C 25.796875 26.394531 25.207031 26.878906 24.570312 27.304688 C 23.933594 27.730469 23.261719 28.089844 22.550781 28.382812 C 21.84375 28.679688 21.113281 28.898438 20.363281 29.050781 C 19.609375 29.199219 18.851562 29.273438 18.085938 29.273438 C 17.316406 29.273438 16.558594 29.199219 15.804688 29.050781 C 15.054688 28.898438 14.324219 28.679688 13.617188 28.382812 C 12.90625 28.089844 12.234375 27.730469 11.597656 27.304688 C 10.960938 26.878906 10.371094 26.394531 9.828125 25.855469 C 9.285156 25.3125 8.800781 24.722656 8.375 24.085938 C 7.949219 23.445312 7.589844 22.773438 7.296875 22.066406 C 7.003906 21.359375 6.78125 20.628906 6.632812 19.875 C 6.484375 19.125 6.410156 18.363281 6.410156 17.597656 C 6.410156 16.832031 6.484375 16.070312 6.632812 15.320312 C 6.78125 14.566406 7.003906 13.835938 7.296875 13.128906 C 7.589844 12.421875 7.949219 11.75 8.375 11.109375 C 8.800781 10.472656 9.285156 9.882812 9.828125 9.339844 C 10.371094 8.800781 10.960938 8.316406 11.597656 7.890625 C 12.234375 7.464844 12.90625 7.105469 13.617188 6.8125 C 14.324219 6.515625 15.054688 6.296875 15.804688 6.144531 C 16.558594 5.996094 17.316406 5.921875 18.085938 5.921875 C 18.851562 5.921875 19.609375 5.996094 20.363281 6.144531 C 21.113281 6.296875 21.84375 6.515625 22.550781 6.8125 C 23.261719 7.105469 23.933594 7.464844 24.570312 7.890625 C 25.207031 8.316406 25.796875 8.800781 26.339844 9.339844 C 26.882812 9.882812 27.367188 10.472656 27.792969 11.109375 C 28.21875 11.75 28.578125 12.421875 28.871094 13.128906 C 29.164062 13.835938 29.386719 14.566406 29.535156 15.320312 C 29.683594 16.070312 29.761719 16.832031 29.761719 17.597656 Z M 29.761719 17.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -3.62791e-8,
    gradientTransform: "matrix(0.364865, 0, 0, 0.364865, 6.408497, 5.922012)",
    y1: 32,
    x2: 63.999992,
    gradientUnits: "userSpaceOnUse",
    y2: 32,
    id: "58727f0b36"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.799927%, 96.499634%, 100%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.72821%, 96.469116%, 100%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.468811%, 96.359253%, 100%)",
    offset: 0.507813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.096497%, 96.200562%, 100%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.724182%, 96.04187%, 100%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.351868%, 95.883179%, 100%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.978027%, 95.726013%, 100%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.605713%, 95.567322%, 100%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.233398%, 95.40863%, 100%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.859558%, 95.249939%, 100%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.487244%, 95.091248%, 100%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.114929%, 94.932556%, 100%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.742615%, 94.775391%, 100%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.368774%, 94.616699%, 100%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.99646%, 94.458008%, 100%)",
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.624146%, 94.299316%, 100%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.250305%, 94.140625%, 100%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.877991%, 93.981934%, 100%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.505676%, 93.824768%, 100%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.131836%, 93.666077%, 100%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.759521%, 93.507385%, 100%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.387207%, 93.348694%, 100%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.014893%, 93.190002%, 100%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.641052%, 93.032837%, 100%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.268738%, 92.874146%, 100%)",
    offset: 0.679687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.896423%, 92.715454%, 100%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.522583%, 92.556763%, 100%)",
    offset: 0.695313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.150269%, 92.398071%, 100%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.777954%, 92.23938%, 100%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.40564%, 92.082214%, 100%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.031799%, 91.923523%, 100%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.659485%, 91.764832%, 100%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.28717%, 91.60614%, 100%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.91333%, 91.447449%, 100%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.541016%, 91.288757%, 100%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.168701%, 91.131592%, 100%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.794861%, 90.9729%, 100%)",
    offset: 0.773437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.422546%, 90.814209%, 100%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.050232%, 90.655518%, 100%)",
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.677917%, 90.496826%, 100%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.304077%, 90.339661%, 100%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.931763%, 90.180969%, 100%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.559448%, 90.022278%, 100%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.185608%, 89.863586%, 100%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.813293%, 89.704895%, 100%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.440979%, 89.546204%, 100%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.068665%, 89.389038%, 100%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.694824%, 89.230347%, 100%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.32251%, 89.071655%, 100%)",
    offset: 0.867187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.950195%, 88.912964%, 100%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.576355%, 88.754272%, 100%)",
    offset: 0.882813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.204041%, 88.595581%, 100%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.831726%, 88.438416%, 100%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.457886%, 88.279724%, 100%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.085571%, 88.121033%, 100%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.713257%, 87.962341%, 100%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.340942%, 87.80365%, 100%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.967102%, 87.644958%, 100%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.594788%, 87.487793%, 100%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.222473%, 87.329102%, 100%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.848633%, 87.17041%, 100%)",
    offset: 0.960937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.476318%, 87.011719%, 100%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.104004%, 86.853027%, 100%)",
    offset: 0.976563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.731689%, 86.695862%, 100%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.357849%, 86.53717%, 100%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.985535%, 86.378479%, 100%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "574c413bb0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 10 L 26 10 L 26 25 L 10 25 Z M 10 10 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c7fa762ec9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.859375 20.386719 L 23.429688 22.332031 C 23.421875 22.636719 23.359375 22.929688 23.242188 23.207031 C 23.125 23.488281 22.957031 23.738281 22.742188 23.953125 C 22.53125 24.167969 22.28125 24.339844 22.003906 24.460938 C 21.726562 24.582031 21.433594 24.644531 21.128906 24.65625 C 20.824219 24.664062 20.53125 24.617188 20.246094 24.511719 C 19.957031 24.40625 19.703125 24.253906 19.476562 24.050781 C 19.25 23.84375 19.070312 23.605469 18.933594 23.335938 C 18.800781 23.0625 18.722656 22.773438 18.699219 22.46875 C 18.515625 22.335938 18.308594 22.273438 18.082031 22.273438 C 17.855469 22.273438 17.652344 22.335938 17.46875 22.46875 C 17.144531 25.449219 12.890625 25.328125 12.734375 22.332031 L 12.308594 20.40625 C 12.285156 20.304688 12.304688 20.207031 12.359375 20.121094 C 12.417969 20.03125 12.496094 19.976562 12.601562 19.953125 C 12.703125 19.929688 12.796875 19.945312 12.886719 20 C 12.976562 20.058594 13.03125 20.136719 13.058594 20.238281 L 13.203125 20.878906 C 13.472656 20.519531 13.816406 20.257812 14.234375 20.09375 C 14.652344 19.929688 15.082031 19.886719 15.523438 19.96875 C 15.96875 20.046875 16.355469 20.238281 16.691406 20.539062 C 17.023438 20.839844 17.253906 21.203125 17.382812 21.636719 C 17.847656 21.4375 18.316406 21.4375 18.78125 21.636719 C 18.90625 21.203125 19.136719 20.832031 19.472656 20.53125 C 19.804688 20.226562 20.195312 20.035156 20.640625 19.957031 C 21.082031 19.878906 21.515625 19.921875 21.933594 20.085938 C 22.351562 20.253906 22.695312 20.519531 22.964844 20.882812 L 23.109375 20.21875 C 23.132812 20.113281 23.191406 20.035156 23.28125 19.976562 C 23.371094 19.921875 23.464844 19.902344 23.570312 19.925781 C 23.675781 19.949219 23.753906 20.007812 23.8125 20.097656 C 23.867188 20.1875 23.882812 20.285156 23.859375 20.386719 Z M 23.585938 15.230469 C 23.707031 15.488281 23.878906 15.84375 23.535156 16.023438 C 23.4375 16.074219 23.335938 16.082031 23.234375 16.042969 C 23.128906 16.007812 23.054688 15.9375 23.011719 15.839844 C 22.410156 14.4375 22.03125 13.386719 21.246094 11.367188 C 21.152344 11.125 21 10.929688 20.785156 10.777344 C 20.574219 10.628906 20.335938 10.550781 20.074219 10.546875 C 19.542969 10.496094 18.808594 11.125 18.371094 11.363281 C 18.1875 11.476562 18.003906 11.476562 17.824219 11.363281 L 16.8125 10.734375 C 16.648438 10.632812 16.476562 10.574219 16.285156 10.550781 C 16.097656 10.527344 15.914062 10.546875 15.734375 10.605469 C 15.554688 10.664062 15.394531 10.757812 15.257812 10.886719 C 15.117188 11.015625 15.011719 11.167969 14.941406 11.34375 C 14.679688 11.988281 13.367188 15.285156 13.136719 15.851562 C 13.105469 15.957031 13.039062 16.03125 12.941406 16.082031 C 12.84375 16.128906 12.742188 16.132812 12.640625 16.097656 C 12.539062 16.058594 12.464844 15.992188 12.421875 15.890625 C 12.375 15.792969 12.375 15.691406 12.414062 15.59375 L 12.425781 15.566406 L 12.554688 15.238281 C 11.605469 15.585938 10.785156 16.105469 10.785156 16.871094 C 10.816406 20.089844 25.355469 20.089844 25.382812 16.871094 C 25.382812 16.101562 24.550781 15.578125 23.585938 15.230469 Z M 23.585938 15.230469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 11.999999,
    gradientTransform: "matrix(0.364865, 0, 0, 0.364865, 6.408497, 5.922012)",
    y1: 32,
    x2: 51.999998,
    gradientUnits: "userSpaceOnUse",
    y2: 32,
    id: "9e08f6626e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 75.299072%, 100%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.1297%, 75.138855%, 100%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.389099%, 74.819946%, 100%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.648499%, 74.501038%, 100%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.909424%, 74.183655%, 100%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.168823%, 73.864746%, 100%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.429749%, 73.545837%, 100%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.689148%, 73.226929%, 100%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.950073%, 72.90802%, 100%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.209473%, 72.589111%, 100%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.470398%, 72.270203%, 100%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.729797%, 71.951294%, 100%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.990723%, 71.632385%, 100%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.250122%, 71.313477%, 100%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.511047%, 70.996094%, 100%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.770447%, 70.677185%, 100%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.031372%, 70.358276%, 100%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.290771%, 70.039368%, 100%)",
    offset: 0.132813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.551697%, 69.720459%, 100%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.811096%, 69.40155%, 100%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.072021%, 69.082642%, 100%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.331421%, 68.763733%, 100%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.592346%, 68.444824%, 100%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.851746%, 68.127441%, 100%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.112671%, 67.808533%, 100%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.37207%, 67.489624%, 100%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.632996%, 67.170715%, 100%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.892395%, 66.851807%, 100%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.15332%, 66.532898%, 100%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.41272%, 66.213989%, 100%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.673645%, 65.895081%, 100%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.933044%, 65.576172%, 100%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.19397%, 65.257263%, 100%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.453369%, 64.93988%, 100%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.714294%, 64.620972%, 100%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.973694%, 64.302063%, 100%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.234619%, 63.983154%, 100%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.494019%, 63.664246%, 100%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.754944%, 63.345337%, 100%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.014343%, 63.026428%, 100%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.275269%, 62.70752%, 100%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.534668%, 62.388611%, 100%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.795593%, 62.069702%, 100%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.054993%, 61.752319%, 100%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.315918%, 61.433411%, 100%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.575317%, 61.114502%, 100%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.836243%, 60.795593%, 100%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.095642%, 60.476685%, 100%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.356567%, 60.157776%, 100%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.615967%, 59.838867%, 100%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.876892%, 59.519958%, 100%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.136292%, 59.20105%, 100%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.397217%, 58.883667%, 100%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.656616%, 58.564758%, 100%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.917542%, 58.24585%, 100%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.176941%, 57.926941%, 100%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.437866%, 57.608032%, 100%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.697266%, 57.289124%, 100%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.958191%, 56.970215%, 100%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.21759%, 56.651306%, 100%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.478516%, 56.332397%, 100%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.737915%, 56.013489%, 100%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.99884%, 55.696106%, 100%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.25824%, 55.377197%, 100%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.519165%, 55.058289%, 100%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.778564%, 54.73938%, 100%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.03949%, 54.420471%, 100%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.298889%, 54.101562%, 100%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.559814%, 53.782654%, 100%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.819214%, 53.463745%, 100%)",
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.080139%, 53.144836%, 100%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.339539%, 52.825928%, 100%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.600464%, 52.508545%, 100%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.859863%, 52.189636%, 100%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.120789%, 51.870728%, 100%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.380188%, 51.551819%, 100%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.641113%, 51.23291%, 100%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.900513%, 50.914001%, 100%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.161438%, 50.595093%, 100%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.420837%, 50.276184%, 100%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.681763%, 49.957275%, 100%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.941162%, 49.639893%, 100%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.202087%, 49.320984%, 100%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.461487%, 49.002075%, 100%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.722412%, 48.683167%, 100%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.981812%, 48.364258%, 100%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.242737%, 48.045349%, 100%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.502136%, 47.72644%, 100%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.763062%, 47.407532%, 100%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.022461%, 47.088623%, 100%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.283386%, 46.769714%, 100%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.542786%, 46.452332%, 100%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.803711%, 46.133423%, 100%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.06311%, 45.814514%, 100%)",
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.324036%, 45.495605%, 100%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.583435%, 45.176697%, 100%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.84436%, 44.857788%, 100%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.10376%, 44.538879%, 100%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.364685%, 44.219971%, 100%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.624084%, 43.901062%, 100%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.88501%, 43.583679%, 100%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.144409%, 43.264771%, 100%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.405334%, 42.945862%, 100%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.664734%, 42.626953%, 100%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.925659%, 42.308044%, 100%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.185059%, 41.989136%, 100%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.445984%, 41.670227%, 100%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.705383%, 41.351318%, 100%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.966309%, 41.03241%, 100%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.225708%, 40.713501%, 100%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.486633%, 40.396118%, 100%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.746033%, 40.077209%, 100%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.006958%, 39.758301%, 100%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.266357%, 39.439392%, 100%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.527283%, 39.120483%, 100%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.786682%, 38.801575%, 100%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.047607%, 38.482666%, 100%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.307007%, 38.163757%, 100%)",
    offset: 0.914063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.567932%, 37.844849%, 100%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.827332%, 37.52594%, 100%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.088257%, 37.208557%, 100%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.347656%, 36.889648%, 100%)",
    offset: 0.945313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.608582%, 36.57074%, 100%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.867981%, 36.251831%, 100%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.128906%, 35.932922%, 100%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.388306%, 35.614014%, 100%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.647705%, 35.295105%, 100%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.90863%, 34.976196%, 100%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.16803%, 34.657288%, 100%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#755640a5c8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8aaa6929d0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#58727f0b36)",
    d: "M 6.410156 5.921875 L 6.410156 29.273438 L 29.761719 29.273438 L 29.761719 5.921875 Z M 6.410156 5.921875 ",
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#574c413bb0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c7fa762ec9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#9e08f6626e)",
    d: "M 10.785156 10.496094 L 10.785156 25.449219 L 25.382812 25.449219 L 25.382812 10.496094 Z M 10.785156 10.496094 ",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLogo);
export default __webpack_public_path__ + "static/media/no_logo.f06f84be9a03e6b0977d0b9c2461b2b1.svg";
export { ForwardRef as ReactComponent };